import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  Row,
  Col,
  Alert
} from "reactstrap";
import { Link } from "react-router-dom";
import has from "mout/object/has";
import forOwn from "mout/object/forOwn";
import convertToAnswerLetters from "../../../helpers/assessment/convertToAnswerLetters";
import sortItems from "../../../helpers/assessment/sortItems";
import getCorrectAnswerLetter from "../../../helpers/assessment/getCorrectAnswerLetter";
import getOneTrueNode from "../../../helpers/assessment/getOneTrueNode";
import addItemNumberToQuery from "../../../helpers/assessment/addItemNumberToQuery";
import { AssessSelectorBar } from "..";
import values from "mout/object/values";
import AssessDashTestSummary from "../AssessDashTestSummary";
import getResumeData from "../../../helpers/assessment/getResumeData";
import getSumData from "../../../helpers/assessment/getSumData";
import newSubtestReport from "../../../helpers/assessment/newSubtestReport";
import assessmentColors from "../../../helpers/assessment/assessmentColors";
import {
  SkillGroups,
  FilterByBar,
  FilterByNode
} from "../AssessOverviewFilter";
import contains from "mout/array/contains";
import { SubjectNavLinks } from "./";
import { BeatLoader } from "react-spinners";
import queryString from "query-string";

/* AssessmentTesting
  <AssessTestOverview
    userAssessment={this.props.userAssessment}
    routeParams={this.props.routeParams}
    search={this.props.search}
    handleSubmitSubtest={this.props.handleSubmitSubtest}
    timeRemaining={this.props.timeRemaining}
    groupUAs={this.props.groupUAs}
    selectedGroupUA={this.props.selectedGroupUA}
    groupUA={this.props.groupUA}
    user={this.props.user}
    assessmentId={this.props.assessmentId}
    subtestId={this.props.subtestId}
    items={this.props.items}
    nodes={this.props.nodes}
    passages={this.props.passages}
    groupData={this.props.groupData}
    selectGroupUA={this.props.selectGroupUA}
    selectStudent={this.props.selectStudent}
    selectedStudent={this.props.selectedStudent}
    query={query}
    navTo={this.props.navTo}
  />
*/

export default function AssessTestOverview(props) {
  const { is_completed, updatingGUA, query, } = props

  function ansTest(filter, correctAnswer, yourAnswer) {
    if (filter === "all") {
      return true;
    } else if (filter === "correct") {
      return correctAnswer == yourAnswer;
    } else if (filter === "incorrect") {
      return correctAnswer != yourAnswer;
    }
  }

  function atLeastOneTrueQ(obj) {
    let atLeastOneTrue = false;
    forOwn(obj, val => {
      !atLeastOneTrue && val ? (atLeastOneTrue = true) : null;
    });
    return atLeastOneTrue;
  }

  function getParentNodes(nodes, childNode, parentNodes) {
    let p = [childNode];
    if (parentNodes) {
      p = parentNodes.slice(0);
    }
    forOwn(nodes[childNode].parents, (val, key) => {
      if (val && !contains(p, key)) {
        p.push(key);
        if (atLeastOneTrueQ(nodes[key].parents)) {
          p = getParentNodes(nodes, key, p);
        }
      }
    });
    return p;
  }

  function ndTest(nodes, filterNode, testedNode) {
    // create array of testedNode and all parents
    const parentNodes = getParentNodes(nodes, testedNode);

    // see if filteredNode is one of those
    return contains(parentNodes, filterNode);
  }

  const contentItems = props.items;
  const nodes = props.nodes;

  let subtestId = "";
  let assessmentDisplayName = "";
  let subTestDisplayName = "";
  var completed = false;
  let assessmentId = "";
  let uA, uACompare, groupUACompare;

  props.routeParams.subTestSetId
    ? (subtestId = props.routeParams.subTestSetId)
    : null;

  if (props.userAssessment) {
    assessmentDisplayName = props.userAssessment.assessmentSet.name;
    assessmentId = props.userAssessment.assessmentSet.id;

    if (subtestId) {
      subTestDisplayName = props.userAssessment.assessmentSubtests[subtestId]
        ? props.userAssessment.assessmentSubtests[subtestId].displayName
        : "";
      completed = props.userAssessment.destructuredSubtests[subtestId]
        ? props.userAssessment.destructuredSubtests[subtestId].complete
        : false;
    }
  } else if (props.groupUA) {
    assessmentDisplayName = props.groupUA.assessmentSet.name;
    assessmentId = props.groupUA.assessmentSet.id;
    completed = true;

    if (props.subtestId) {
      subTestDisplayName =
        props.groupUA.assessmentSubtests[props.subtestId].displayName;
    }
  }

  let items = [];
  if (
    contentItems &&
    nodes &&
    props.userAssessment &&
    subtestId &&
    (props.user.role === "Student" || props.selectedStudent)
  ) {
    let userAssessment = props.userAssessment
    if(props.isSwap) {
      userAssessment = null ;
      userAssessment = props.userAssessmentCompare ;    
    }

    uA = userAssessment;
    if(userAssessment && userAssessment !== null && has(userAssessment, 'destructuredSubtests')){
      userAssessment.destructuredSubtests[subtestId].items.forEach(
        (item, n) => {
          let yourAnswer = "";
          if (has(userAssessment, `answersByItem.${subtestId}.${item}`)) {
            yourAnswer = convertToAnswerLetters(
              n + 1,
              userAssessment.answersByItem[subtestId][item]
            );
          }
  
          const correctKey = userAssessment.answers && userAssessment && userAssessment.answers[subtestId][n];
          const correctAnswer = convertToAnswerLetters(n + 1, correctKey);
  
          let query = `item=${n + 1}`;
          if (props.selectedStudent) {
            query = addItemNumberToQuery(props.search, n + 1);
          }
  
          const contentItem = contentItems[item];
          let nodeId = "",
            nodeName = "";
          if (contentItem) {
            nodeId = getOneTrueNode(contentItem.nodeTags);
            nodeName = nodes[nodeId].name;
          }
          let isCorrect = '';
          if (yourAnswer !== '') {
            isCorrect = correctAnswer === yourAnswer ? '#8fcd86' : '#ff0000';
          }
          const itemRow = (
  
            <tr key={`itemRow${item}`} className="tr_hover" style={{ backgroundColor: isCorrect, cursor: 'pointer' }} onClick={() => props.navTo(`?${query}`)}>
              <td>
                <Link to={`?${query}`}>{n + 1}</Link>
              </td>
              <td>{yourAnswer === "" ? <i>Not Answered</i> : yourAnswer}</td>
              <td>{completed ? correctAnswer : ""}</td>
              <td>{nodeName}</td>
            </tr>
          );
  
          const ansPass =
            !props.query.ans ||
            ansTest(props.query.ans, correctAnswer, yourAnswer);
          const ndPass = !props.query.nd || ndTest(nodes, props.query.nd, nodeId);
  
          if (ansPass && ndPass) {
            items.push(itemRow);
          }
        }
      );
    }
    
  } else if (props.groupUA && props.subtestId && contentItems && nodes) {

    uA = props.groupUA;
    uACompare = props.groupUACompare && props.groupUACompare
    if(props.isSwap){
      uA = null
      uACompare = null
      uA = props.groupUACompare && props.groupUACompare ;
      uACompare =  props.groupUA;
    }

    if(uA && uA !== null && has(uA, 'scoring') ){ 
    // sort items
    const itemScores = uA.scoring.byItem && sortItems(uA.scoring.byItem[subtestId]);
    // then, for each item, pull skill and correct answer
    itemScores.forEach((item, n) => {
      const contentItem = contentItems[item.itemId];
      const correctAnswer = getCorrectAnswerLetter(contentItem);
      const nodeId = getOneTrueNode(contentItem.nodeTags);
      const nodeName = nodes[nodeId].name;
      const percent = Math.round((item.raw / item.possible) * 100);
      const query = addItemNumberToQuery(props.search, n + 1);

      const ndPass = !props.query.nd || ndTest(nodes, props.query.nd, nodeId);

      let percentColor = '';
      if (percent <= 33) {
        percentColor = 'red';
      } else if (percent > 33 && percent <= 66) {
        percentColor = 'orange';
      } else {
        percentColor = 'green';
      }

      ndPass
        ? items.push(

          <tr key={`itemRow${item.itemId}${n}`} className="tr_hover" style={{ cursor: 'pointer' }} onClick={() => props.navTo(`?${query}`)}>
            <td>
              <Link to={`?${query}`}>{n + 1}</Link>
            </td>
            <td>{correctAnswer}</td>
            <td style={{ color: percentColor }}>{`${percent}%`}</td>
            <td>{nodeName}</td>
          </tr>
        )
        : null
    })
    }
  }

  if (items === []) {
    items = <tr />;
  }

  let button = (
    <Link to="?item=results">
      <Button onClick={() => props.handleSubmitSubtest()} color="primary">
        Submit Answers
      </Button>
    </Link>
  );

  if (completed || props.user.role !== "Student") {
    let link = `/assessment/dashboard/${assessmentId}`;
    if (props.selectedGroupUA && props.user.role !== "Student") {
      let studentParam = "";
      if (props.selectedStudent) {
        studentParam = `&s=${props.selectedStudent}`;
      }
      link = `/assessment/dashboard/${assessmentId}?gua=${
        props.selectedGroupUA
        }${studentParam}`;
    }

    button = (
      <Link to={link}>
        <Button color="primary" className="mt-3">
          Return to Dashboard
        </Button>
      </Link>
    );
  }

  let headerRow;
  if (props.user.role === "Student" || props.selectedStudent) {
    headerRow = (
      <tr>
        <th>Question Number</th>
        <th>Your Answer</th>
        <th>Correct Answer</th>
        <th>Skill</th>
      </tr>
    );
  } else {
    headerRow = (
      <tr>
        <th>Question Number</th>
        <th>Correct Answer</th>
        <th>% Correct</th>
        <th>Skill</th>
      </tr>
    );
  }

  let assessSelectorBar = null;
  const groupDataCheck =
    !!props.groupData.districts &&
    !!props.groupData.schools &&
    !!props.groupData.schools &&
    !!props.groupData.educators &&
    !!props.groupData.students;
  if (
    props.user.role !== "Student" &&
    groupDataCheck &&
    props.selectedGroupUA
  ) {
    assessSelectorBar = (
      <AssessSelectorBar
        selectedGroupUA={props.selectedGroupUA}
        groupUAs={props.groupUAs}
        groupData={props.groupData}
        assessmentId={props.assessmentId}
        role={props.user.role}
        selectGroupUA={props.selectGroupUA}
        selectStudent={props.selectStudent}
        selectedStudent={props.selectedStudent}
        updatingGUA={updatingGUA}
        year={props.year}
      />
    );
  }

  let alert = null;
  let is_show_card = true;
  let needAlert = "";
  if (props.user.role !== "Student") {
    if (props.selectedStudent && has(props, "userAssessment.answersByItem")) {
      if (props.userAssessment.answersByItem[props.subtestId]) {
        if (
          values(props.userAssessment.answersByItem[props.subtestId]).length < 1
        ) {
          needAlert = "Student";
        }
      } else {
        needAlert = "Student";
      }
    } else if (props.groupUA) {
      if (props.groupUA.answersByItem[props.subtestId]) {
        if (values(props.groupUA.answersByItem[props.subtestId]).length < 1) {
          needAlert = "Group";
        }
      } else {
        needAlert = "Group";
      }
    } else {
      needAlert = "Group";
    }
  }
  if (needAlert === "Student") {
    alert = (
      <Alert color="warning">This student has not taken this test, yet.</Alert>
    );
    is_show_card = false;
  } else if (needAlert === "Group") {
    alert = (
      <Alert color="warning">
        No selected students have taken this test, yet.
      </Alert>
    );
    is_show_card = false;
  }
  let firstIncompleteSubtest = null;
  let topResume = false;
  let topTitle = `${subTestDisplayName} (${assessmentDisplayName})`;
  let topComplete = false;

  if (props.userAssessment) {
    const resData = getResumeData(props.userAssessment);
    if (resData) {
      firstIncompleteSubtest = resData.firstIncompleteSubtest;
      topResume = resData.topResume;
    }
  }
    let  gUA ;
    let  gUACompare ;
    if (
      props.user.role !== "Student" &&
      props.selectedGroupUA &&
      props.groupUAs &&
      props.groupUAs[props.selectedGroupUA]
    ) {
      if (props.groupUAs[props.selectedGroupUA][props.year]) {
        
        gUA = props.groupUA
        gUACompare = props.groupUACompare 
      }
    }
    
  

  let sumData1 = {};
  if (props.userAssessment && props.user.role === "Student") {
    sumData1.userAssessmentId = props.userAssessment.userAssessmentId;
    sumData1.scoring = props.userAssessment.scoring;
    sumData1.subtests = props.userAssessment.assessmentSubtests;
  } else if (props.userAssessment && props.selectedStudent) {
    sumData1.userAssessmentId = props.userAssessment.userAssessmentId;
    sumData1.scoring = props.userAssessment.scoring;
    sumData1.subtests = props.userAssessment.assessmentSubtests;
  } else if (gUA) {
    sumData1.groupUAId = props.selectedGroupUA;
    sumData1.scoring = gUA.scoring;
    sumData1.subtests = gUA.assessmentSubtests;
  }
  let sumDataCompare1 = {};
  if (props.userAssessment && props.user.role === "Student") {
    sumDataCompare1.userAssessmentId = props.userAssessmentCompare && props.userAssessmentCompare.userAssessmentId;
    sumDataCompare1.scoring = props.userAssessmentCompare && props.userAssessmentCompare.scoring;
    sumDataCompare1.subtests = props.userAssessmentCompare && props.userAssessmentCompare.assessmentSubtests;
  } else if ((props.userAssessment) && props.selectedStudent) {
    sumDataCompare1.userAssessmentId = props.userAssessmentCompare && props.userAssessmentCompare.userAssessmentId;
    sumDataCompare1.scoring = props.userAssessmentCompare && props.userAssessmentCompare.scoring;
    sumDataCompare1.subtests = props.userAssessmentCompare && props.userAssessmentCompare.assessmentSubtests;
  } else if (gUACompare) {
    sumDataCompare1.groupUAId = props.selectedGroupUACompare;
    sumDataCompare1.scoring = gUACompare.scoring;
    sumDataCompare1.subtests = gUACompare.assessmentSubtests;
  }1
  
  let sumData = {};
 let sumDataCompare ={};
  let swapArray
  if(props.isSwap ){
    sumData = sumDataCompare1;
    sumDataCompare =sumData1;
    
  }else{
    sumData = sumData1;
    sumDataCompare =sumDataCompare1;
  }
 



  if (props.userAssessment) {
    topComplete = props.userAssessment.scoring.byTest.complete === true;
  } else if (props.selectedGroupUA) {
    topComplete = true;
  }

  let newReport, newReportCompare;
  if (uA && subtestId && nodes) {
    newReport = newSubtestReport(
      sumData.scoring,
      uA.assessmentSubtests[subtestId],
      nodes,
      uA.assessmentSet.maxNodeLevels
    );
  }

  if (sumDataCompare.scoring && uA && subtestId && nodes) {
    newReportCompare = newSubtestReport(
      sumDataCompare.scoring,
      uA.assessmentSubtests[subtestId],
      nodes,
      uA.assessmentSet.maxNodeLevels
    );
  }

  let scaleScore;
  if (
    sumData &&
    sumData.scoring &&
    sumData.scoring.bySubtest[props.subtestId]
  ) {
    scaleScore = sumData.scoring.bySubtest[props.subtestId].scale;
  }

  let scaleScoreCompare;
  if (
    sumDataCompare &&
    sumDataCompare.scoring &&
    sumDataCompare.scoring.bySubtest[props.subtestId]
  ) {
    scaleScoreCompare = sumDataCompare.scoring.bySubtest[props.subtestId].scale;
  }

  let printPath = "";
  const year = props.year;
  if (props.userAssessment && props.user.role === "Student") {
    printPath = `/assessment/print/${props.userAssessment.userAssessmentId}`;
  } else if (sumData) {
    printPath = `/assessment/print/${sumData.groupUAId}?g=true&a=${
      props.assessmentId
      }&y=${year}`;
  }

  let filterApplied = false;
  let clearFilterLink = "";
  if (query.nd || query.ans) {
    filterApplied = true;
    let clearFilterQuery = { ...query };
    delete clearFilterQuery.nd;
    delete clearFilterQuery.ans;
    clearFilterLink = `?${queryString.stringify(clearFilterQuery)}`;
  }

  //let leftRow = {};

  let rightRow = {
    maxHeight: "555px",
    overflowY: "auto",
    overflowX: "hidden"
  };

  const { isFetchingGroupUAs } = props;
  const nullGUACheck = !(
    props.user.role !== "Student" &&
    groupDataCheck &&
    !props.groupUA
  );
  const selectHeaderStye = {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "-21px"
  };
  let leftRow = {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "hidden"
  };
  return (
    <div>
      <div style={selectHeaderStye}>{assessSelectorBar}</div>

      <Row className="assess-test-overview">
        {sumData && (nullGUACheck || isFetchingGroupUAs) && (
          <AssessDashTestSummary
            sm="12"
            md="12"
            lg="12"
            xl="12"
            sub={false}
            topTitle={topTitle}
            subtest={firstIncompleteSubtest}
            topResume={topResume}
            userAssessmentId={
              sumData.userAssessmentId ? sumData.userAssessmentId : ""
            }
            groupUAId={sumData.groupUAId ? sumData.groupUAId : ""}
            groupUAIdCompare={sumDataCompare.groupUAId ? sumDataCompare.groupUAId : ""}
            scoring={sumData.scoring}
            scoringCompare = {sumDataCompare && sumDataCompare.scoring}
            subtests={sumData.subtests}
            topComplete={topComplete}
            assessmentId={assessmentId}
            selectedGroupUA={props.selectedGroupUA}
            selectedStudent={props.selectedStudent}
            isStudent={props.user.role === "Student"}
            needAlert={needAlert}
            groupUA={props.groupUA}
            userAssessment={props.userAssessment}
            user={props.user}
            activeSubtest={props.subtestId ? props.subtestId : ""}
            printPath={printPath}
            notInitializing={!isFetchingGroupUAs}
            currentAssessmentId={props.currentAssessmentId}
            compareAssessmentId={props.compareAssessmentId}
            isCompare={props.isCompare}
            test1={props.test1}
            test2={props.test2}
            isSwap={props.isSwap}
          />
        )}
        {!nullGUACheck && !isFetchingGroupUAs && (
          <Alert>No selected students have taken this subtest, yet.</Alert>
        )}
        {!sumData && isFetchingGroupUAs && (
          <Card>
            <CardBody>
              <BeatLoader loading={isFetchingGroupUAs} color={"#00C1AB"} />
            </CardBody>
          </Card>
        )}
        {props.aFetchingAllItems && props.aFetchingAllPassages ? (
          <Col xs="12" xl="12">
            <Card>
              <CardBody className="text-center card-loader">
                <BeatLoader loading={true} color={"#00C1AB"} />
              </CardBody>
            </Card>
          </Col>
        ) : (
            <Col xs="12" xl="12">
              {sumData && newReport && (
                <Card>
                  <div className="item-report-nav">
                    {sumData && (
                      <SubjectNavLinks
                        subtests={sumData.subtests}
                        uAid={props.routeParams.userAssessmentId}
                        query={props.query}
                        activeSubtest={props.subtestId}
                        />
                        )}
                  </div>
                  <CardHeader>
                    {/* {`${assessmentDisplayName}: ${subTestDisplayName} Overview`} */}
                    {filterApplied && (
                      <Link to={clearFilterLink}>
                        {/* <Button>Remove Filter</Button> */}
                      </Link>
                    )}
                  </CardHeader>
                  {is_completed === false && props.user.role === "Student" ? (
                    <CardBody>
                      <Alert color="success">
                        You have not completed this subtest, yet.
                    </Alert>
                    </CardBody>
                  ) : (
                      <CardBody>
                        {alert}

                        {is_show_card && (
                          <Row>
                            {newReport && (
                              <Col
                              xs="12"
                              sm="5"
                              lg="4"
                              className="item-report-skills"
                              style={leftRow}
                              >
                                <SkillGroups
                                  routeParams={props.routeParams}
                                  report={newReport}
                                  reportCompare={newReportCompare}
                                  color={assessmentColors(
                                    subTestDisplayName,
                                    false
                                  )} 
                                  scaleScore={scaleScore} 
                                  scaleScoreCompare={scaleScoreCompare}  
                                  name={subTestDisplayName} 
                                  query={props.query} 
                                  navTo={props.navTo} 
                                  assessmentId={assessmentId} 
                                  isStudent={props.user.role === "Student"} 
                                  isCompare={props.isCompare} 
                                  test1={props.test1} 
                                  test2={props.test2} 
                                  isSwap={props.isSwap} 
                                />
                              </Col> 
                            )}
                            <Col xs="12" sm="7" lg="8">
                              <div style={{ color: '#2a3e49', fontSize: '24px', fontWeight: 'bolder', marginBottom: '11px' }}>
                                {`${assessmentDisplayName}: ${subTestDisplayName} Overview`}

                              </div>
                              {(props.user.role === "Student" ||
                                props.selectedStudent) && (
                                  <FilterByBar
                                    query={props.query}
                                    navTo={props.navTo}
                                  />
                                )}
                              {is_show_card && newReport && (
                                <FilterByNode
                                  newReport={newReport}
                                  query={props.query}
                                  navTo={props.navTo}
                                  selectedOption={props.selectedOption}
                                />
                              )}
                              <Card className="item-report-table" style={rightRow}>
                                <Table>
                                  <thead>{headerRow}</thead>
                                  <tbody>{items}</tbody>
                                </Table>
                              </Card>
                            </Col>
                          </Row>
                        )}
                        {is_show_card && button}
                      </CardBody>
                    )}
                </Card>
              )}
              {(!sumData || !newReport) && isFetchingGroupUAs && (
                <Card>
                  <CardBody>
                    <BeatLoader loading={isFetchingGroupUAs} color={"#00C1AB"} />
                  </CardBody>
                </Card>
              )}
            </Col>
          )}
      </Row>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestOverview.js